module.exports = __webpack_public_path__ + "img/preview.66338a64.png";